import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-esi-compliance-grid',
  templateUrl: './esi-compliance-grid.component.html',
  styleUrls: ['./esi-compliance-grid.component.css']
})
export class EsiComplianceGridComponent implements OnInit {
  title="ESI Compliance";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/esi-compliances/esi-compliance-grid/esi-compliance-grid.component.ts